module.exports = __webpack_public_path__ + "img/1F1EC-1F1E9.683caa38.svg";